import React from 'react';

import classNames from 'classnames';
import { TextBrick } from 'src/components/TextBrick';

import s from './ChartDataLoadingWrapper.module.scss';
import { TChartDataLoadingWrapperProps } from './ChartDataLoadingWrapper.types';

export const ChartDataLoadingWrapper: React.FC<TChartDataLoadingWrapperProps> = ({
  children,
  className,
  loading,
}) => {
  return (
    <div className={classNames(s.container, className)}>
      {children}
      {loading && (
        <div className={s.overlayer}>
          <TextBrick>Loading Data</TextBrick>
        </div>
      )}
    </div>
  );
};
